import React, { useEffect, useState } from 'react';
import { Block, ImageBlockContent, LinkBlockContent, PdfBlockContent } from '../types';
import { ControlPanelSwitchButton } from './control-panel/switch';
import { useBlockActions } from '../helpers/actions/use-block-actions.hook';
import { apiDeleteContent, apiGetAllContents } from 'src/utils/journeyApi'; // Updated import
import { useCurrentOrganization } from 'src/store/organization';
import { Content } from 'src/common/interfaces/content.interface';
import { useNotificationMessage } from 'src/common/notification/message.hook';

interface Props {
  block: Block;
  contentObject: { [key: string]: any };
  icon?: JSX.Element | undefined;
  isVideoOrDocument?: boolean;
}

export const TogglePersonalContent = ({ block, contentObject, isVideoOrDocument, icon }: Props) => {
  const blockContent = block?.content as LinkBlockContent | ImageBlockContent;
  const [contentsList, setContentsLists] = useState<Content[] | undefined>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingToggle, setLoadingToggle] = useState(false);
  const [isProgressDocumentToggle, setIsProgressDocumentToggle] = useState(true);

  const { onBlockParamsChange } = useBlockActions(block);
  const { setSuccessNotification, setErrorNotification } = useNotificationMessage();

  const fetchContents = async (page = 1) => {
    const response = await apiGetAllContents(useCurrentOrganization.getState().currentOrganization.id, { page });
    setContentsLists(response?.contents);
    setTotalPages(response?.pages);
    setCurrentPage(page);
    return {
      contents: response?.contents,
      pages: response?.pages,
    };
  };

  useEffect(() => {
    fetchContents();
  }, [block]);

  const checkContentUUID = async() =>{

    if(block?.id){

      setLoadingToggle(true);

      const blockContentUUID = blockContent?.contentUUID;
      if(blockContentUUID){

        const contentsList = await fetchContents()

        let contentFound = false;
        let currentPageIndex = currentPage;
        let content = contentsList?.contents.find((content: any) => `${content.uuid}` == `${blockContentUUID}`);
  
        while (!content && currentPageIndex < totalPages && !contentFound) {
          const { contents: newContentsList } = await fetchContents(currentPageIndex + 1);
          content = newContentsList.find((content: any) => `${content.uuid}` == `${blockContent.contentUUID}`);
          currentPageIndex++;
          contentFound = !!content;
        }

        if(content){
          onBlockParamsChange(block.id, {
            personalContent: false,
            contentObject,
            staticShow: true
          });

          setLoadingToggle(false);

          return;
        }
      
      }

      onBlockParamsChange(block.id, {
        personalContent: true,
        contentObject,
        staticShow: true
      });

      setLoadingToggle(false);
   
    }
  }

  useEffect(()=>{
    if(!isVideoOrDocument){
      checkContentUUID()
    }
  },[])

  useEffect(()=>{
    if(isVideoOrDocument && block && block.content && isProgressDocumentToggle){

      setIsProgressDocumentToggle(true)

      const pdfBlockContent = block.content as PdfBlockContent;

      if(pdfBlockContent.fileUploadStatus==='complete'){
        checkContentUUID()
        setIsProgressDocumentToggle(false);
        return;
      }

    }
  },[block])

  const handleRemoveFromLibrary = async (value: boolean) => {
    if (blockContent?.contentUUID && contentsList) {
      let contentFound = false;
      let currentPageIndex = currentPage;
      let content = contentsList.find((content: any) => `${content.uuid}` == `${blockContent.contentUUID}`);

      while (!content && currentPageIndex < totalPages && !contentFound) {
        const { contents: newContentsList } = await fetchContents(currentPageIndex + 1);
        content = newContentsList.find((content: any) => `${content.uuid}` == `${blockContent.contentUUID}`);
        currentPageIndex++;
        contentFound = !!content;
      }

      if (content) {
        apiDeleteContent(content?.id)
          .catch((err) => {
            setErrorNotification('It was not possible to remove the library content');
          })
          .then(() => {
            setSuccessNotification('Content removed from the library');
            onBlockParamsChange(block.id, {
              personalContent: !value,
              contentObject,
            });
          });
      } else {
        setErrorNotification('Content not found');
      }
    }
  };

  const handleAddToLibrary = async (value: boolean) => {
    if(block?.id){
      onBlockParamsChange(block.id, {
        personalContent: !value,
        contentObject,
      });
      setSuccessNotification('Content added to the library');
    }
  };

  return (
    <ControlPanelSwitchButton
      label='Add to Library'
      disabled={isVideoOrDocument?isProgressDocumentToggle:loadingToggle}
      icon={icon}
      checked={!(blockContent.personalContent)}
      onChange={(value) => {
        if (blockContent.personalContent && value) {
          handleAddToLibrary(value);
        } else {
          handleRemoveFromLibrary(value);
        }
      }}
    />
  );
};